import { ArrowDown, ArrowUp, Minus } from "lucide-react";
import { AnimatePresence, motion } from "framer-motion";

export function previewScore(components, weights) {
  const usable = (components || []).filter((c) => c.status === "complete" && c.value != null && (Number(weights[c.key]) || 0) > 0);
  const tw = usable.reduce((a, c) => a + Number(weights[c.key]), 0);
  if (!tw) return null;
  return Math.round(usable.reduce((a, c) => a + (10 * Number(weights[c.key]) * c.value) / 100 / tw, 0) * 10) / 10;
}

const rank = (rows, scoreOf) => rows.map((r) => ({ ...r, s: scoreOf(r) })).filter((r) => r.s != null).sort((a, b) => b.s - a.s);

export function WeightsPreview({ rows, current, draft }) {
  const before = rank(rows, (r) => previewScore(r.components, current));
  const after = rank(rows, (r) => previewScore(r.components, draft));
  const pos = Object.fromEntries(before.map((r, i) => [r.application_id, i]));
  const top = after.slice(0, 5);
  return (
    <div className="space-y-2 rounded-[6px] border border-brand/15 bg-brand-tint/40 p-3" data-testid="weights-preview" aria-live="polite">
      <p className="text-xs font-semibold text-brand">Top 5 would become…</p>
      <ol className="space-y-1">
        <AnimatePresence initial={false}>
          {top.map((r, i) => {
            const d = (pos[r.application_id] ?? i) - i;
            return (
              <motion.li layout key={r.application_id} initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }} className="flex items-center gap-2 text-sm" data-testid={`weights-preview-row-${i}`}>
                <span className="w-4 text-xs tabular-nums text-ink-muted">{i + 1}</span>
                <span className="min-w-0 flex-1 truncate">{r.name}</span>
                <span className="font-display font-semibold tabular-nums">{r.s.toFixed(1)}</span>
                <span className={`flex w-9 items-center justify-end text-xs tabular-nums ${d > 0 ? "text-success" : d < 0 ? "text-risk" : "text-ink-muted"}`} data-testid={`weights-preview-move-${i}`}>
                  {d > 0 ? <><ArrowUp size={12} aria-label="up" />{d}</> : d < 0 ? <><ArrowDown size={12} aria-label="down" />{-d}</> : <Minus size={12} aria-label="no change" />}
                </span>
              </motion.li>
            );
          })}
        </AnimatePresence>
      </ol>
      {!top.length && <p className="text-xs text-ink-muted">No scored candidates to preview yet.</p>}
    </div>
  );
}
